import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { VenueRentalProps } from "./types";
import {
    PropertyDefinition
} from "app/library/layout-builder";

export class VenueRentalDefinitions extends CmsReactComponent<VenueRentalProps> {

    static schemaName = "venue-rental";

    static propertyDefinitions: PropertyDefinition[] = [];

}
